import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatSelectChange } from '@angular/material/select';
import { TranslateService } from '@ngx-translate/core';
import { RefundPolicyService } from 'src/app/features/restaurants/services/Cancellation.service';
import { DirtyComponent } from 'src/app/helpers/CanDeactivate/dirty-component';
import { CustomValidator } from 'src/app/helpers/custom.validator';
import { Patterns } from 'src/app/helpers/patterns';
import Swal from 'sweetalert2';
import { Record, ReservationType } from '../../../../../models/List.Cancellation';


export interface DialogData {
  record: Record,
  restaurantsId: number,
  id: string
}
@Component({
  selector: 'app-cancellation-form',
  templateUrl: './cancellation-form.component.html'
})
export class CancellationFormComponent extends DirtyComponent implements OnInit {

  Intervals!: ReservationType[];
  period?: any;
  periodUnit?: any;
  refund?: any;

  time?: any
  timeUnit?: any


  override formGroup!: FormGroup;
  loading = false;
  isSubmitted = false;

  isUpdate: boolean = this.data.record ? true : false;
  constructor(override dialogRef: MatDialogRef<CancellationFormComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData, private formBuilder: FormBuilder,
    translate: TranslateService, private service: RefundPolicyService) {
    super(translate);
  }

  ngOnInit(): void {
    this.buildForm();
    if (this.isUpdate) {
      this.bindDataToUpdate();
    }
    this.GetReservationTimeType()
  }

  buildForm() {
    this.formGroup = this.formBuilder.group({
      title_EN: [null, [
        CustomValidator.noWhiteSpace,
        Validators.maxLength(50),
        // Validators.pattern(Patterns.enTxtWithSpecial),
        Validators.required
      ]],
      title_AR: [null, [
        CustomValidator.noWhiteSpace,
        Validators.maxLength(50),
        // Validators.pattern(Patterns.arTxtWithSpecial),
        Validators.required
      ]],
      restaurantId: this.data.restaurantsId,
      refund: [null, [
        Validators.required,
        Validators.maxLength(5),
        Validators.min(0.001),
        Validators.max(100),
        Validators.pattern(Patterns.float)]],
      beforeTime: [null,[Validators.required, Validators.pattern(Patterns.number),  Validators.maxLength(10),]],
      beforeTimeType: [null, Validators.required],
      // afterTime: [null,[Validators.required, Validators.pattern(Patterns.number),  Validators.maxLength(10),]],
      // afterTimeType: [null, Validators.required],
    });
  }
  hasError(controlName: string, errorName: string) {
    return this.formGroup.controls[controlName].hasError(errorName);
  }
  override canDeactivate(): boolean {
    return this.formGroup.dirty;
  };

  bindDataToUpdate() {
    this.service.GetPolicyById(this.data.id, this.data.restaurantsId).subscribe((data: any) => {
      this.formGroup.patchValue({
        title_EN: data.title_EN,
        title_AR: data.title_AR,
        restaurantId: this.data.restaurantsId,
        refund: data.refund,
        beforeTime: data.beforeTime,
        beforeTimeType: data.beforeTimeType,
        // afterTime: data.afterTime,
        // afterTimeType: data.afterTimeType
      });
    })
  }

  onPeriodUnitChange(event: MatSelectChange) {
    this.periodUnit = event.source.triggerValue
    console.log(this.periodUnit);
  }
  onTimeUnitChange(event: MatSelectChange) {
    this.timeUnit = event.source.triggerValue
    console.log(this.timeUnit);
  }
  saveRecord(openNew: boolean = false) {
    this.isSubmitted = true;
    if (this.formGroup.valid) {
      this.loading = true;
      let data = {
        id: '',
        title_EN: this.formGroup.controls['title_EN'].value,
        title_AR: this.formGroup.controls['title_AR'].value,
        restaurantId: this.data.restaurantsId,
        refund: this.formGroup.controls['refund'].value,
        beforeTime: this.formGroup.controls['beforeTime'].value,
        beforeTimeType: this.formGroup.controls['beforeTimeType'].value,
        // afterTime: this.formGroup.controls['afterTime'].value,
        // afterTimeType: this.formGroup.controls['afterTimeType'].value,
      };

      let msg = this.translate.instant('swalMsg.savedsuccessfully');
      if (this.isUpdate) {
        data.id = this.data.id;
        msg = this.translate.instant('swalMsg.updatedsuccessfully');
      }
      this.service.savePolicyRecord(data).subscribe(() => {
        this.loading = false;
        Swal.fire({
          title: this.translate.instant('swalMsg.Success'),
          text: msg,
          icon: 'success',
          confirmButtonText: this.translate.instant('swalMsg.Ok')
        });
        if (openNew) {
          this.formGroup.reset();
          this.service.refreshList.next(true);
        } else {
          this.dialogRef.close(true);
        }
      }, error => {
        this.loading = false;
        Swal.fire({
          title: this.translate.instant('swalMsg.Failed'),
          text: error.detail,
          icon: 'error',
          confirmButtonText: this.translate.instant('swalMsg.Ok'),
        });
      });
    }
  }


  GetReservationTimeType() {
    this.service.GetReservationTimeType().subscribe((data: ReservationType[]) => {
      this.Intervals = data;
    })
  }
}
